/* Keep complimentary PipPounce services in sync with all Rolling Tails in the cart. */
(() => {
  const mainVariant = 47511135617113;
  const giftMinimums = new Map([
    [47511718264921, 2], // Shipping Protection
    [47511719051353, 3], // Priority Processing
    [47511719116889, 3]  // 90-Day Guarantee
  ]);
  const addonVariants = new Set([47511775150169, 47511775215705, 47511775248473]);
  const shopRoot = window.Shopify?.routes?.root || '/';
  const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
  let working = false;
  let rerun = false;

  async function readCart() {
    const response = await fetch(`${shopRoot}cart.js`, {headers: {'Accept': 'application/json'}});
    if (!response.ok) throw new Error('Could not read the cart.');
    return response.json();
  }

  async function postCart(path, payload) {
    const response = await fetch(`${shopRoot}${path}`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({...payload, sections: sectionIds, sections_url: window.location.pathname})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Could not synchronize PipPounce gifts.');
    return result;
  }

  async function refreshCartView(cart) {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }

    const response = await fetch(`${shopRoot}?sections=${sectionIds.join(',')}&_pp=${Date.now()}`, {cache: 'no-store'});
    if (!response.ok) throw new Error('Could not refresh the cart drawer.');
    const sections = await response.json();

    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
        drawer.renderContents({...cart, sections});
      } else {
        const next = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const current = document.querySelector('#CartDrawer');
        if (next && current) current.innerHTML = next.innerHTML;
      }
      drawer.classList.toggle('is-empty', cart.item_count === 0);
    }

    const nextBubble = sections['cart-icon-bubble'] && new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
    const bubble = document.getElementById('cart-icon-bubble');
    if (nextBubble && bubble) bubble.innerHTML = nextBubble.innerHTML;
  }

  async function reconcile() {
    if (working) { rerun = true; return; }
    working = true;
    try {
      const cart = await readCart();
      const toyQuantity = cart.items.reduce((sum, item) => sum + (item.id === mainVariant ? item.quantity : 0), 0);
      const updates = {};
      const keptGifts = new Set();

      for (const item of cart.items) {
        const minimum = giftMinimums.get(item.id);
        if (minimum !== undefined) {
          if (toyQuantity < minimum || keptGifts.has(item.id)) updates[item.key] = 0;
          else {
            keptGifts.add(item.id);
            if (item.quantity !== 1) updates[item.key] = 1;
          }
        }
        if (toyQuantity === 0 && addonVariants.has(item.id) && item.properties?.['_PipPounce add-on']) {
          updates[item.key] = 0;
        }
      }

      const missingGifts = [...giftMinimums].filter(([id, minimum]) => toyQuantity >= minimum && !keptGifts.has(id));
      if (!Object.keys(updates).length && !missingGifts.length) return;

      if (Object.keys(updates).length) await postCart('cart/update.js', {updates});
      if (missingGifts.length) {
        const items = missingGifts.map(([id]) => ({
          id,
          quantity: 1,
          properties: {'_PipPounce gift': `${toyQuantity} Rolling Tails`}
        }));
        await postCart('cart/add.js', {items});
      }

      await refreshCartView(await readCart());
    } catch (error) {
      console.error('[PipPounce offer]', error);
    } finally {
      working = false;
      if (rerun) { rerun = false; queueMicrotask(reconcile); }
    }
  }

  document.addEventListener('cartQuantityUpdated', () => setTimeout(reconcile, 150));
  document.addEventListener('DOMContentLoaded', reconcile, {once: true});
})();
